// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1ChmM","legacyBtn":"MutateMid_legacyBtn__2LBiG"};